exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3_QndMLrl0DS7txXsKk5aM {\n    color: #5b2699;\n}\n\n._1QSb_Lywz03jNMCELm-GrU {\n    padding-right: 16px;\n    padding-right: 1rem;\n    white-space: nowrap;\n}\n\n._3a5669pwdwJabgmbtJHumc {\n    line-height: 1.3;\n}\n\n._3Xlbyq0Qo-JOAJLLx2z9-l {\n    color: #64381f;\n}\n\n.NgU4gHjdynLJU2YSbF4ic {\n    color: #836c28;\n}\n\n._15sahXcXCjIULC63jwKqZE {\n    color: #007400;\n}\n\n._1ssUqN390ygEtVlxHSnU0e,\n._1ssUqN390ygEtVlxHSnU0e:active,\n._1ssUqN390ygEtVlxHSnU0e:hover,\n._1ssUqN390ygEtVlxHSnU0e:visited {\n    color: #007400;\n}\n", ""]);

// exports
exports.locals = {
	"argumentName": "_3_QndMLrl0DS7txXsKk5aM",
	"argumentCell": "_1QSb_Lywz03jNMCELm-GrU",
	"argumentRow": "_3a5669pwdwJabgmbtJHumc",
	"fieldName": "_3Xlbyq0Qo-JOAJLLx2z9-l",
	"defaultValue": "NgU4gHjdynLJU2YSbF4ic",
	"typeName": "_15sahXcXCjIULC63jwKqZE",
	"typeLink": "_1ssUqN390ygEtVlxHSnU0e"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/_base.css
 ** module id = 17
 ** module chunks = 0
 **/